import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useMutation } from '@tanstack/react-query'
import { toast } from '@/components/custom-toast'
import { updateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteMutation } from '@/generated/@tanstack/react-query.gen'
import { DialogDescription } from '@radix-ui/react-dialog'
import { useUser } from '@/pages/enterprise/user-provider'

interface IProps {
  organizationId: number
  userId: string
  isHiddenTrigger?: boolean
  onDeleted?: () => void
  open: boolean
  setOpen: (open: boolean) => void
}

export default function DeleteUserModal(props: IProps) {
  const { open, setOpen, onDeleted } = props
  const { onUpdateSeats } = useUser()
  const mutate = useMutation({
    ...updateOrganizationUserOrganizationOrganizationIdUsersUseruuidDeleteMutation(
      {}
    ),
    onError: (error) => {
      toast.error({
        message:
          (error.response?.data.detail as unknown as string) ?? error.message,
      })
    },
    onSuccess: () => {
      onUpdateSeats()
      onDeleted && onDeleted()
      toast.success({
        message: 'User deleted successfully.',
      })
      setOpen(false)
    },
  })

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {props.isHiddenTrigger ? null : (
        <DialogTrigger asChild>
          <Button
            className="!opacity-100 text-destructive"
            size={'sm'}
            variant="window"
          >
            Delete
          </Button>
        </DialogTrigger>
      )}
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete User</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Are you sure you want to delete this user?
        </DialogDescription>
        <DialogFooter className="flex !justify-start">
          <Button
            className="px-6"
            disabled={mutate.isPending}
            onClick={() => {
              mutate.mutate({
                path: {
                  organization_id: props.organizationId,
                  useruuid: props.userId,
                },
              })
            }}
            variant="destructive"
          >
            Delete
          </Button>
          <DialogClose asChild>
            <Button
              variant="ghost"
              className="text-primary hover:text-emerald-500 hover:bg-transparent"
            >
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
